import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Announcement} from '../models/announcement';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementService {

  constructor(private http: HttpClient) {
  }

  public getDashboardAnnouncements(): Observable<Announcement[]> {
    return this.http.get<Announcement[]>(`${environment.api_url}/announcement/dashboard-announcements`);
  }

  public getAllAnnouncements(): Observable<Announcement[]> {
    return this.http.get<Announcement[]>(`${environment.api_url}/announcement/all`);
  }

}
